import Link from 'next/link';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import CloudinaryImage from '../common/CloudinaryImage';
import Container from '../common/Container';

export default function DevelopmentCost({ devcost, setModalCall = false }) {
  return (
    <Container>
      <div
        className={devcost?.title && 'lg:mb-[35px] mb-[30px] max-w-[1200px]'}
      >
        {devcost?.title && (
          <h2
            className={`font-[800] xl:text-[55px] md:text-[32px] text-[25px] leading-tight mb-3 text-[#0C2139]`}
          >
            {devcost?.title}
          </h2>
        )}
        {devcost?.description && (
          <p className="lg:text-[20px] text-[16px] font-[400] text-[#25384D]">
            {devcost?.description}
          </p>
        )}
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-10">
        {devcost?.CostBlog?.map((data, index, array) => (
          <div
            key={data?.id}
            className={`rounded-[20px] py-8 px-8 shadow-[10px_10px_20px_0px_#00000017] ${data?.btn_txt?.trim() ? 'bg-[linear-gradient(179.82deg,_#014ED1_10.83%,_#010102_123.6%)]' : 'bg-[#F0F5FF]'}`}
          >
            <div className="flex items-center">
              {data?.icon?.data?.attributes?.url && (
                <CloudinaryImage
                  backendImgUrl={data?.icon?.data?.attributes?.url}
                  width={'70px'}
                  height={'70px'}
                  className={'lg:w-[70px] lg:h-[70px] w-[50px] h-[50px]'}
                  alt={data?.icon?.data?.attributes?.alternativeText}
                  type="icon"
                />
              )}
              {data?.price_number && (
                <h4
                  className={`text-[#00102B] md:text-[28px] text-[22px] font-[700] ml-1`}
                >
                  {data?.price_number}
                </h4>
              )}
            </div>
            {data?.title && (
              <h6
                className={`leading-tight ${data?.btn_txt?.trim() ? 'md:text-[28px] text-[22px] font-[700] text-[#fff]' : 'text-[18px] font-[500] text-[#353535] mb-4'}`}
              >
                {data?.title}
                {index !== array.length - 1 && (
                  <span className="bg-[#0050D5] w-[60px] h-[4px] block mt-1"></span>
                )}
              </h6>
            )}
            {data?.description && (
              <p className="text-[16px] font-[400] text-[#383838]">
                {data?.description}
              </p>
            )}
            {data?.editor && (
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                className="text-[#303030] group-hover:text-[#fff] lg:text-[16px] md:text-[16px] text-[14px] font-[400] pb-2"
                source={data?.editor}
                transformImageUri={uri =>
                  uri.startsWith('http')
                    ? uri
                    : `${process.env.NEXT_PUBLIC_API_URL}${uri}`
                }
              >
                {data?.editor}
              </ReactMarkdown>
            )}
            {data?.link ? (
              <Link
                className="inline-block btnleftright relative overflow-hidden bg-[#FFF] shadow-[0px_30px_40px_0px_#0C1A4B14] py-3 px-7 md:text-[20px] text-[14px] font-[500] mt-4 rounded-[4px]"
                href={`${data?.link}`}
              >
                <span className="relative z-[5] transition duration-300 ease-in-out">
                  {data?.btn_txt}
                </span>
              </Link>
            ) : data?.btn_txt ? (
              <button
                className="inline-block btnleftright relative overflow-hidden bg-[#FFF] shadow-[0px_30px_40px_0px_#0C1A4B14] py-3 px-7 md:text-[20px] text-[14px] font-[500] mt-4 rounded-[4px]"
                onClick={() => setModalCall(data?.btn_txt)}
              >
                <span className="relative z-[5] transition duration-300 ease-in-out">
                  {data?.btn_txt}
                </span>
              </button>
            ) : (
              ''
            )}
          </div>
        ))}
      </div>
      <div className="text-center">
        {devcost?.btn_link ? (
          <Link
            className="inline-block btnleftright relative overflow-hidden bg-[#0050D5] text-white shadow-[0px_30px_40px_0px_#0C1A4B14] py-3 px-7 md:text-[20px] text-[14px] font-[500] mt-10 rounded-[4px]"
            href={`${devcost?.btn_link}`}
          >
            <span className="relative z-[5] transition duration-300 ease-in-out">
              {devcost?.btn_txt}
            </span>
          </Link>
        ) : devcost?.btn_txt ? (
          <button
            className="inline-block btnleftright relative overflow-hidden bg-[#0050D5] text-white shadow-[0px_30px_40px_0px_#0C1A4B14] py-3 px-7 md:text-[20px] text-[14px] font-[500] mt-10 rounded-[4px]"
            onClick={() => setModalCall(devcost?.btn_txt)}
          >
            <span className="relative z-[5] transition duration-300 ease-in-out">
              {devcost?.btn_txt}
            </span>
          </button>
        ) : (
          ''
        )}
      </div>
    </Container>
  );
}
